import { render, staticRenderFns } from "./sideCard.vue?vue&type=template&id=0ea2ff04&"
import script from "./sideCard.vue?vue&type=script&lang=js&"
export * from "./sideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports